/**
 * HelloWorld Client Mod — 注册器
 *
 * 通过 DI 获取 UI Registry 服务，
 * 在构造函数中注册页面、状态、组件和 Hook。
 */
import { atom } from 'jotai';
import { HelloWorldComponent } from './components/hello-world.js';
import { useGreeting } from './hooks/use-greeting.js';
export class HelloworldRegistrar {
    constructor(deps) {
        const { pageRouteRegistry, globalStateRegistry, componentRegistry, hooksRegistry, } = deps;
        // ─── 1. 注册页面路由 ───
        pageRouteRegistry.registerPage({
            path: '/',
            component: HelloWorldComponent,
            key: 'helloworld-home',
            meta: {
                title: 'Hello World',
                requiresAuth: false,
            },
            modName: 'helloworld-client',
        });
        pageRouteRegistry.registerPage({
            path: '/helloworld',
            component: HelloWorldComponent,
            key: 'helloworld-page',
            meta: {
                title: 'Hello World',
                requiresAuth: false,
            },
            modName: 'helloworld-client',
        });
        // ─── 2. 注册全局状态（jotai atoms）───
        globalStateRegistry.registerStates('helloworld-client', {
            greeting: atom({ name: 'World', count: 0 }),
        });
        // ─── 3. 注册可复用组件 ───
        componentRegistry.registerComponents('helloworld-client', {
            HelloWorld: HelloWorldComponent,
        });
        // ─── 4. 注册 Hooks ───
        hooksRegistry.registerHooks('helloworld-client', {
            useGreeting,
        });
    }
}
//# sourceMappingURL=helloworld-registrar.js.map